import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

import MomentUtils from "@date-io/moment";
import { Grid, Switch, Tooltip } from "@material-ui/core";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { useDispatch } from "react-redux";
import { handleKeyDown } from "../../../../common/common";
import SplitHireModal from "../../../../components/Calculator/SplitHireModal";
import {
  vesselCalculatorMainFields
} from "../../../../constants";
import { checkValidation } from "../../../../utils";
import * as commonActions from "../../../Common/actions";

export const initialRowData = {
  userId: '0',
  version: '0',
  system: false,
  vesselName: '',
  vesselDwt: '0',
  vesselDraftS: '0',
  vesselTPC: '0',
  vesselGrainCap: '0',
  vesselBalSpd1: '0',
  vesselBalConsmHS1: '0',
  vesselBalConsmLS1: '0',
  vesselBalConsmMGO1: '0',
  vesselBalComb1Selected: false,
  vesselBalSpd2: '0',
  vesselBalConsmHS2: '0',
  vesselBalConsmLS2: '0',
  vesselBalConsmMGO2: '0',
  vesselBalComb2Selected: false,
  vesselBalSpd3: '0',
  vesselBalConsmHS3: '0',
  vesselBalConsmLS3: '0',
  vesselBalConsmMGO3: '0',
  vesselBalComb3Selected: false,
  vesselBalSpd4: '0',
  vesselBalConsmHS4: '0',
  vesselBalConsmLS4: '0',
  vesselBalConsmMGO4: '0',
  vesselBalComb4Selected: false,
  vesselLdnSpd1: '0',
  vesselLdnConsmHS1: '0',
  vesselLdnConsmLS1: '0',
  vesselLdnConsmMGO1: '0',
  vesselLadComb1Selected: false,
  vesselLdnSpd2: '0',
  vesselLdnConsmHS2: '0',
  vesselLdnConsmLS2: '0',
  vesselLdnConsmMGO2: '0',
  vesselLadComb2Selected: false,
  vesselLdnSpd3: '0',
  vesselLdnConsmHS3: '0',
  vesselLdnConsmLS3: '0',
  vesselLdnConsmMGO3: '0',
  vesselLadComb3Selected: false,
  vesselLdnSpd4: '0',
  vesselLdnConsmHS4: '0',
  vesselLdnConsmLS4: '0',
  vesselLdnConsmMGO4: '0',
  vesselLadComb4Selected: false,
  vesselPIdleConsmHS: '0',
  vesselPIdleConsmLS: '0',
  vesselPIdleConsmMGO: '0',
  vesselPLdgConsmHS: '0',
  vesselPLdgConsmLS: '0',
  vesselPLdgConsmMGO: '0',
  vesselPDischConsmHS: '0',
  vesselPDischConsmLS: '0',
  vesselPDischConsmMGO: '0',
  vesselVExtraConsmHS: '0',
  vesselVExtraConsmMGO: '0',
  vesselVExtraConsmLS: '0',
  vesselLightShip: '0',
  vesselBaleCap: '0',
  vesselGears: '0',
  vesselBuilt: '0',
  vesselLOA: '0',
  vesselBeam: '0',
  vesselGRT: '0',
  vesselNRT: '0',
  vesselIMO: '0',
  vesselGrabs: '0',
  vesselFlag: '0',
  vesselClass: '0',
  vesselHolds: '0',
  vesselAHL: '0',
  vesselShipyard: '0',
  vesselMMSI: '0',
  vesselType: '0',
  pattern: '0',
  vesselLabel: '',
  vesselExtraDetails: {
    vesselTextDescription: '0',
    suezGRT: '0',
    panamaNT: '0',
    mgoCapacity: '0',
    phone1: '0',
    phone2: '0',
    tropicalFreshDraft: '0',
    tropicalFreshDisplacement: '0',
    tropicalFreshDwt: '0',
    tropicalFreshFreeBoard: '0',
    freshDisplacement: '0',
    freshFreeBoard: '0',
    tropicalDisplacement: '0',
    tropicalDwt: '0',
    summerDisplacement: '0',
    winterDisplacement: '0',
    winterDwt: '0',
    winterNorthAtlanticDraft: '0',
    winterNorthAtlanticDisplacement: '0',
    winterNorthAtlanticDwt: '0',
    pandIClub: '0',
    holdCapacity: [],
  }
};


export const initialVessel = {
  bnkDelhs: 0,
  bnkDells: 0,
  bnkDelmgo: 0,
  bnkPriceDeliveryhs: 0,
  bnkPriceDeliveryls: 0,
  bnkPriceDeliverymgo: 0,
  bnkPriceRedeliveryhs: 0,
  bnkPriceRedeliveryls: 0,
  bnkPriceRedeliverymgo: 0,
  bnkPriceSettlemenths: 0,
  bnkPriceSettlementls: 0,
  bnkPriceSettlementmgo: 0,
  bnkQtyRedeliveryhs: 0,
  bnkQtyRedeliveryls: 0,
  bnkQtyRedeliverymgo: 0,
  bnkFuelMain: '',
  bnkFuelEca: '',
  bnkFuelMgo: '',
  bnkRedeliveryQtyTolerancehs: 0,
  bnkRedeliveryQtyTolerancels: 0,
  bnkRedeliveryQtyTolerancemgo: 0,
  bunkerPriceOverridden: false,
  dateOpen: Date.now(),
};
const EditVesselOnFleetAdd = forwardRef((props, ref) => {
  const {
    setLoader = () => { },
    setValidationVessel,
    setAddFleetsArray = () => { },
    addFleetsArray,
    onValidationVesselIndex = 0,
    onClickAddFleet = () => { },
    isFromCreateVessel = false,
  } = props;
  const [vessel, setVessel] = useState({});
  const [isOverride, setIsOverride] = useState(false);
  useEffect(() => {
    setVessel({
      ...initialVessel,
      selectedVessel: {
        ...initialRowData,
        ...addFleetsArray[onValidationVesselIndex]?.selectedVessel,
      },
      ...addFleetsArray[onValidationVesselIndex],
    });
  }, []);

  const onChangeHandler = (e, isExtra = false, isCheckbox = false, preventEmpty = true) => {
    const { name = "", value = "", checked } = e.target;
    const updatedVessel = { ...vessel };
    const selectedVessel = updatedVessel.selectedVessel || {};
    const vesselExtraDetails = selectedVessel.vesselExtraDetails || {};

    const finalValue = isCheckbox
      ? checked
      : value === "" && preventEmpty
        ? "0"
        : value;

    if (isExtra) {
      vesselExtraDetails[name] = finalValue;
      updatedVessel.selectedVessel.vesselExtraDetails = vesselExtraDetails;
    } else {
      updatedVessel.selectedVessel[name] = finalValue;
    }

    setVessel(updatedVessel);
  };
  const dispatch = useDispatch();
  const onOpenErrorAlert = (errors = []) => {
    dispatch(commonActions.openErrorAlert({ errorList: errors }));
  };
  const onSubmitUpdateVessel = () => {
    if (vessel?.selectedVessel) {
      let updatedVal = [...addFleetsArray];
      updatedVal[onValidationVesselIndex] = vessel;
      const error = checkValidation(vessel, vessel?.selectedVessel, 4);
      if (error?.length) {
        return onOpenErrorAlert(error);
      }
      updatedVal[onValidationVesselIndex].isValidate = true;
      setAddFleetsArray(updatedVal);
      setValidationVessel(false);
    }
  };

  useImperativeHandle(ref, () => ({
    onSubmitUpdateVessel,
  }));

  const {
    vesselName = "",
    vesselDwt = 0,
    vesselIMO = 0,
    vesselBalSpd1 = 0,
    vesselBalConsmHS1 = 0,
    vesselBalConsmLS1 = 0,
    vesselBalConsmMGO1 = 0,
    vesselBalSpd2 = 0,
    vesselBalConsmHS2 = 0,
    vesselBalConsmLS2 = 0,
    vesselBalConsmMGO2 = 0,
    vesselBalSpd3 = 0,
    vesselBalConsmHS3 = 0,
    vesselBalConsmLS3 = 0,
    vesselBalConsmMGO3 = 0,
    vesselBalSpd4 = 0,
    vesselBalConsmHS4 = 0,
    vesselBalConsmLS4 = 0,
    vesselBalConsmMGO4 = 0,
    vesselLdnSpd1 = 0,
    vesselLdnConsmHS1 = 0,
    vesselLdnConsmLS1 = 0,
    vesselLdnConsmMGO1 = 0,
    vesselLdnSpd2 = 0,
    vesselLdnConsmHS2 = 0,
    vesselLdnConsmLS2 = 0,
    vesselLdnConsmMGO2 = 0,
    vesselLdnSpd3 = 0,
    vesselLdnConsmHS3 = 0,
    vesselLdnConsmLS3 = 0,
    vesselLdnConsmMGO3 = 0,
    vesselLdnSpd4 = 0,
    vesselLdnConsmHS4 = 0,
    vesselLdnConsmLS4 = 0,
    vesselLdnConsmMGO4 = 0,
    vesselPIdleConsmHS = 0,
    vesselPIdleConsmLS = 0,
    vesselPIdleConsmMGO = 0,
    vesselPLdgConsmHS = 0,
    vesselPLdgConsmLS = 0,
    vesselPLdgConsmMGO = 0,
    vesselPDischConsmHS = 0,
    vesselPDischConsmLS = 0,
    vesselPDischConsmMGO = 0,
    vesselVExtraConsmHS = 0,
    vesselVExtraConsmLS = 0,
    vesselVExtraConsmMGO = 0,
    vesselBalComb1Selected = false,
    vesselBalComb2Selected = false,
    vesselBalComb3Selected = false,
    vesselBalComb4Selected = false,
    vesselLadComb1Selected = false,
    vesselLadComb2Selected = false,
    vesselLadComb3Selected = false,
    vesselLadComb4Selected = false,
    vesselExtraDetails = {},
  } = vessel?.selectedVessel || {};

  const addNewSplitHire = () => {
    let splitHire =
      (vessel && vessel.splitHire && JSON.parse(vessel.splitHire)) || [];
    if (!!splitHire.find((item) => item.NoDays === 0)) return;
    splitHire.push({ NoDays: 0, applied: 0, disable: false, hireRate: 0 });
    setVessel({
      ...vessel,
      splitHire: JSON.stringify(splitHire),
    });
  };
  const onChangeBunkerPriceOverridden = (e) => {
    let { name = "", checked = "" } = e.target || {};
    let newUpdatedFleet = { ...vessel };
    newUpdatedFleet[name] = checked;
    setVessel(newUpdatedFleet);
  };
  const onChangeSplitHire = (index, e, isDelete = false) => {
    let splitHire =
      (vessel && vessel.splitHire && JSON.parse(vessel.splitHire)) || [];
    if (isDelete) splitHire.splice(index, 1);
    else {
      const { name = "", value = "" } = e.target;
      splitHire[index][name] = Number(value);
    }
    const udpatedvessel = {
      ...vessel,
      splitHire: JSON.stringify(splitHire),
    };
    setVessel(udpatedvessel);
  };

  const onChangeSelectedVessel = (e, fieldname = "", isDate = false) => {
    let name = "";
    let value = "";

    if (isDate) {
      name = fieldname;
      value = e;
    } else {
      name = e?.target?.name;
      value = e?.target?.value;
    }

    setVessel((prevVessel) => {
      const updatedVessel = { ...prevVessel };

      if (name === "vesselTextDescription") {
        if (!updatedVessel.selectedVessel) updatedVessel.selectedVessel = {};
        if (!updatedVessel.selectedVessel.vesselExtraDetails)
          updatedVessel.selectedVessel.vesselExtraDetails = {};

        updatedVessel.selectedVessel.vesselExtraDetails[name] = value;
      } else {
        updatedVessel[name] = value;
      }

      return updatedVessel;
    });
  };

  const vesselOnChangeHandler = (e) => {
    const { name = "", value = "" } = e.target;
    setVessel((prevVessel) => {
      const updatedVessel = { ...prevVessel };
      updatedVessel[name] = value;
      return updatedVessel;
    });
  };


  const {
    bnkDelhs = 0,
    bnkDells = 0,
    bnkDelmgo = 0,
    bnkPriceDeliveryhs = 0,
    bnkPriceDeliveryls = 0,
    bnkPriceDeliverymgo = 0,
    bnkPriceRedeliveryhs = 0,
    bnkPriceRedeliveryls = 0,
    bnkPriceRedeliverymgo = 0,
    bnkPriceSettlemenths = 0,
    bnkPriceSettlementls = 0,
    bnkPriceSettlementmgo = 0,
    bnkQtyRedeliveryhs = 0,
    bnkQtyRedeliveryls = 0,
    bnkQtyRedeliverymgo = 0,
    bnkRedeliveryQtyTolerancehs = 0,
    bnkRedeliveryQtyTolerancels = 0,
    bnkRedeliveryQtyTolerancemgo = 0,
    bunkerPriceOverridden = false,
    constants = 0,
    extraExpense = 0,
  } = vessel || {};
  return (
    <Grid container className="w-full">
      {/* Left 8 Columns on desktop: Vessel Details & Consumptions & Bunker */}
      <Grid item xs={12} lg={8} className="lg:pr-3 mb-3 lg:mb-0">
        <Grid container>
          {/* Top Section: Vessel Details & Sea/Port Consumptions */}
          <Grid item xs={12} className="border-b border-slate-300 pb-2 mb-2">
            <div>
              <Grid container>
                <Grid item xs={12}>
                  <div className="flex items-center gap-3 w-full mb-1.5">
                    <div className="flex items-center gap-1.5 w-[150px] shrink-0">
                      <span className="text-[11px] font-medium text-slate-600 whitespace-nowrap">Vessel</span>
                      <input
                        disabled={true}
                        value={vesselName}
                        type="text"
                        name="vesselName"
                        className="h-[20px] px-1.5 text-[11px] font-medium bg-white border border-slate-300 w-full outline-none"
                        onChange={onChangeHandler}
                      />
                    </div>
                    <div className="flex items-center gap-1.5 w-[85px] shrink-0">
                      <span className="text-[11px] font-medium text-slate-600 whitespace-nowrap">Dwt</span>
                      <input
                        disabled={!isFromCreateVessel}
                        value={vesselDwt}
                        name="vesselDwt"
                        className="h-[20px] px-1.5 text-[11px] font-medium bg-[#ffffd6] border border-slate-300 w-full outline-none disabled:bg-white"
                        onChange={onChangeHandler}
                      />
                    </div>
                    <div className="flex items-center gap-1.5 w-[90px] shrink-0">
                      <span className="text-[11px] font-medium text-slate-600 whitespace-nowrap">IMO</span>
                      <input
                        disabled={!isFromCreateVessel}
                        value={vesselIMO}
                        name="vesselIMO"
                        className="h-[20px] px-1.5 text-[11px] font-medium bg-[#ffffd6] border border-slate-300 w-full outline-none disabled:bg-white"
                        onChange={onChangeHandler}
                      />
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={5} className="sm:pr-1.5 mb-2 sm:mb-0">
                  <table className="fleet-result-table vesselDetails">
                    <tbody>
                      {vesselCalculatorMainFields.map((item, key) => {
                        if (
                          item.name === "fuelType" ||
                          item.name === "vesselScrubber"
                        )
                          return null;
                        return (
                          <tr key={key}>
                            <th>{item.label}</th>
                            <td>
                              <input
                                value={
                                  vessel?.selectedVessel?.[item.name] ?? (item.type === "number" ? 0 : "")
                                }
                                type={item.type}
                                onKeyDown={handleKeyDown}
                                name={item.name}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Grid>
                <Grid item xs={12} sm={7} className="sm:pl-1.5">
                  <Grid container>
                    <Grid item xs={12}>
                      <div className="text-[12px] font-medium text-slate-800 mb-1 leading-tight">
                        Ballast Sea Consumptions
                      </div>
                      <table className="vessel-details-tables w-full mb-2" style={{ tableLayout: "fixed" }}>
                        <thead>
                          <tr>
                            <th style={{ width: "8%", textAlign: "center" }}></th>
                            <th style={{ width: "23%" }}>Speed</th>
                            <th style={{ width: "23%" }}>Main</th>
                            <th style={{ width: "23%" }}>ECA</th>
                            <th style={{ width: "23%" }}>MGO</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <input
                                type="checkbox"
                                className="input-type-checkbox"
                                name="vesselBalComb1Selected"
                                checked={vesselBalComb1Selected || false}
                                onChange={(e) =>
                                  onChangeHandler(e, false, true)
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalSpd1"
                                value={vesselBalSpd1 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmHS1"
                                value={vesselBalConsmHS1 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmLS1"
                                value={vesselBalConsmLS1 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmMGO1"
                                value={vesselBalConsmMGO1 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="checkbox"
                                className="input-type-checkbox"
                                name="vesselBalComb2Selected"
                                checked={vesselBalComb2Selected || false}
                                // onChange={onChangeHandler}
                                onChange={(e) =>
                                  onChangeHandler(e, false, true)
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalSpd2"
                                value={vesselBalSpd2 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmHS2"
                                value={vesselBalConsmHS2 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmLS2"
                                value={vesselBalConsmLS2 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmMGO2"
                                value={vesselBalConsmMGO2 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="checkbox"
                                className="input-type-checkbox"
                                name="vesselBalComb3Selected"
                                checked={vesselBalComb3Selected || false}
                                // onChange={onChangeHandler}
                                onChange={(e) =>
                                  onChangeHandler(e, false, true)
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalSpd3"
                                value={vesselBalSpd3 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmHS3"
                                value={vesselBalConsmHS3 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmLS3"
                                value={vesselBalConsmLS3 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmMGO3"
                                value={vesselBalConsmMGO3 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="checkbox"
                                className="input-type-checkbox"
                                name="vesselBalComb4Selected"
                                checked={vesselBalComb4Selected || false}
                                // onChange={onChangeHandler}
                                onChange={(e) =>
                                  onChangeHandler(e, false, true)
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalSpd4"
                                value={vesselBalSpd4 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmHS4"
                                value={vesselBalConsmHS4 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmLS4"
                                value={vesselBalConsmLS4 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselBalConsmMGO4"
                                value={vesselBalConsmMGO4 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Grid>

                    <Grid item xs={12}>
                      <div className="text-[12px] font-medium text-slate-800 mt-2.5 mb-1 leading-tight">
                        Laden Sea Consumptions
                      </div>
                      <table className="vessel-details-tables w-full mb-2" style={{ tableLayout: "fixed" }}>
                        <thead>
                          <tr>
                            <th style={{ width: "8%", textAlign: "center" }}></th>
                            <th style={{ width: "23%" }}>Speed</th>
                            <th style={{ width: "23%" }}>Main</th>
                            <th style={{ width: "23%" }}>ECA</th>
                            <th style={{ width: "23%" }}>MGO</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <input
                                type="checkbox"
                                className="input-type-checkbox"
                                name="vesselLadComb1Selected"
                                checked={vesselLadComb1Selected || false}
                                // onChange={onChangeHandler}
                                onChange={(e) =>
                                  onChangeHandler(e, false, true)
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnSpd1"
                                value={vesselLdnSpd1 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmHS1"
                                value={vesselLdnConsmHS1 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmLS1"
                                value={vesselLdnConsmLS1 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmMGO1"
                                value={vesselLdnConsmMGO1 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="checkbox"
                                className="input-type-checkbox"
                                name="vesselLadComb2Selected"
                                checked={vesselLadComb2Selected || false}
                                // onChange={onChangeHandler}
                                onChange={(e) =>
                                  onChangeHandler(e, false, true)
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnSpd2"
                                value={vesselLdnSpd2 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmHS2"
                                value={vesselLdnConsmHS2 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmLS2"
                                value={vesselLdnConsmLS2 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmMGO2"
                                value={vesselLdnConsmMGO2 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="checkbox"
                                className="input-type-checkbox"
                                name="vesselLadComb3Selected"
                                checked={vesselLadComb3Selected || false}
                                // onChange={onChangeHandler}
                                onChange={(e) =>
                                  onChangeHandler(e, false, true)
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnSpd3"
                                value={vesselLdnSpd3 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmHS3"
                                value={vesselLdnConsmHS3 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmLS3"
                                value={vesselLdnConsmLS3 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmMGO3"
                                value={vesselLdnConsmMGO3 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="checkbox"
                                className="input-type-checkbox"
                                name="vesselLadComb4Selected"
                                checked={vesselLadComb4Selected || false}
                                // onChange={onChangeHandler}
                                onChange={(e) =>
                                  onChangeHandler(e, false, true)
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnSpd4"
                                value={vesselLdnSpd4 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmHS4"
                                value={vesselLdnConsmHS4 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmLS4"
                                value={vesselLdnConsmLS4 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselLdnConsmMGO4"
                                value={vesselLdnConsmMGO4 || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Grid>
                    <Grid item xs={12}>
                      <div className="text-[12px] font-medium text-slate-800 mt-2.5 mb-1 leading-tight">
                        Port Consumptions
                      </div>
                      <table className="vessel-details-tables w-full" style={{ tableLayout: "fixed" }}>
                        <thead>
                          <tr>
                            <th style={{ width: "37%" }}></th>
                            <th style={{ width: "21%" }}>Main</th>
                            <th style={{ width: "21%" }}>ECA</th>
                            <th style={{ width: "21%" }}>MGO</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th>Idle</th>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselPIdleConsmHS"
                                value={vesselPIdleConsmHS || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselPIdleConsmLS"
                                value={vesselPIdleConsmLS || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselPIdleConsmMGO"
                                value={vesselPIdleConsmMGO || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Loading</th>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselPLdgConsmHS"
                                value={vesselPLdgConsmHS || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselPLdgConsmLS"
                                value={vesselPLdgConsmLS || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselPLdgConsmMGO"
                                value={vesselPLdgConsmMGO || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Disch</th>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselPDischConsmHS"
                                value={vesselPDischConsmHS || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselPDischConsmLS"
                                value={vesselPDischConsmLS || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselPDischConsmMGO"
                                value={vesselPDischConsmMGO || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                          <tr>
                            <Tooltip placement="top" arrow title={<span className="text-sm">Any Additional Lupsum Consumption in the entire voyage</span>}>
                              <th>Extras</th>
                            </Tooltip>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselVExtraConsmHS"
                                value={vesselVExtraConsmHS || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselVExtraConsmLS"
                                value={vesselVExtraConsmLS || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                name="vesselVExtraConsmMGO"
                                value={vesselVExtraConsmMGO || ""}
                                onChange={onChangeHandler}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

            </div>
          </Grid>
          {/* second box */}
          <Grid item xs={12}>
            <Grid container>
              {/* split hire and bunker related stuff */}
              <Grid item xs={12} sm={6} className="sm:pr-1.5 mb-2 sm:mb-0">
                <div className="text-[12px] font-medium text-slate-700 mb-1 leading-tight">
                  Split hire
                </div>
                <SplitHireModal
                  addNewSplitHire={addNewSplitHire}
                  selectedSplitHire={vessel}
                  onChangeSplitHire={onChangeSplitHire}
                />

                {/* expenses related stuff */}
                <div className="mt-2.5">
                  <table className="fleet-result-table w-full">
                    <tbody>
                      <tr>
                        <th style={{ width: "35%" }}>Extra Expenses</th>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            onChange={(e) => onChangeSelectedVessel(e, true)}
                            value={(vessel && vessel.extraExpense) || 0}
                            name="extraExpense"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Constants</th>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            onChange={(e) => onChangeSelectedVessel(e, true)}
                            value={(vessel && vessel.constants) || 0}
                            name="constants"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="mt-2.5">
                  <table className="fleet-result-table w-full">
                    <thead>
                      <tr>
                        <th colSpan="2" style={{ background: "#f1f5f9", color: "#334155" }}>
                          Bunker Fuel specifications
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th style={{ width: "25%" }}>Main</th>
                        <td>
                          <Tooltip
                            title={<span className="text-xs">{vessel?.bnkFuelMain || 'empty'}</span>}
                            placement="top"
                            arrow
                          >
                            <input
                              name="bnkFuelMain"
                              type="text"
                              maxLength={100}
                              placeholder=""
                              value={vessel?.bnkFuelMain || ''}
                              onChange={vesselOnChangeHandler}
                            />
                          </Tooltip>
                        </td>
                      </tr>
                      <tr>
                        <th>ECA</th>
                        <td>
                          <Tooltip
                            title={<span className="text-xs">{vessel?.bnkFuelEca || 'empty'}</span>}
                            placement="top"
                            arrow
                          >
                            <input
                              name="bnkFuelEca"
                              type="text"
                              maxLength={100}
                              placeholder=""
                              value={vessel?.bnkFuelEca || ''}
                              onChange={vesselOnChangeHandler}
                            />
                          </Tooltip>
                        </td>
                      </tr>
                      <tr>
                        <th>MGO</th>
                        <td>
                          <Tooltip
                            title={<span className="text-xs">{vessel?.bnkFuelMgo || 'empty'}</span>}
                            placement="top"
                            arrow
                          >
                            <input
                              name="bnkFuelMgo"
                              type="text"
                              maxLength={100}
                              placeholder=""
                              value={vessel?.bnkFuelMgo || ''}
                              onChange={vesselOnChangeHandler}
                            />
                          </Tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Grid>

              {/* Right Bottom Column: Date Opening, Bunker Qty & Prices */}
              <Grid item xs={12} sm={6} className="sm:pl-1.5">
                <table className="fleet-result-table w-full">
                  <tbody>
                    <tr>
                      <th style={{ width: "34%" }}>Date Opening</th>
                      <td>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                          <DateTimePicker
                            inputVariant="outlined"
                            size="small"
                            name="dateOpen"
                            className="date-time-picker-update-fleet"
                            style={{ width: "100%", background: "#ffffd6" }}
                            value={(vessel && vessel.dateOpen) || Date.now()}
                            onChange={(date) =>
                              onChangeSelectedVessel(date, "dateOpen", true)
                            }
                            format="MMM DD, YYYY HH:mm"
                            ampm={false}
                          />
                        </MuiPickersUtilsProvider>
                      </td>
                    </tr>
                    <tr>
                      <th>Hire Per Day</th>
                      <td>
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          value={(vessel && vessel.hirePerDay) || 0}
                          name="hirePerDay"
                          className="custom-input-field"
                          onChange={(e) => onChangeSelectedVessel(e, true)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Hire GBB</th>
                      <td>
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          value={(vessel && vessel.hireGbb) || 0}
                          name="hireGbb"
                          className="custom-input-field"
                          onChange={(e) => onChangeSelectedVessel(e, true)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Bunker Qty */}
                <div className="mt-2.5">
                  <table className="fleet-result-table w-full" style={{ tableLayout: "fixed" }}>
                    <thead>
                      <tr>
                        <th style={{ width: "37%" }}>Bunker Qty</th>
                        <th style={{ width: "21%" }}>Main</th>
                        <th style={{ width: "21%" }}>ECA</th>
                        <th style={{ width: "21%" }}>MGO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>On Delivery</th>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkDelhs}
                            name="bnkDelhs"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkDells}
                            name="bnkDells"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkDelmgo}
                            name="bnkDelmgo"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Exp on Re-Delivery</th>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkQtyRedeliveryhs}
                            name="bnkQtyRedeliveryhs"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkQtyRedeliveryls}
                            name="bnkQtyRedeliveryls"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkQtyRedeliverymgo}
                            name="bnkQtyRedeliverymgo"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Tolerance Acceptable</th>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkRedeliveryQtyTolerancehs}
                            name="bnkRedeliveryQtyTolerancehs"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkRedeliveryQtyTolerancels}
                            name="bnkRedeliveryQtyTolerancels"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkRedeliveryQtyTolerancemgo}
                            name="bnkRedeliveryQtyTolerancemgo"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Override Switch */}
                <div className="sync-bunker-switch flex justify-end items-center my-1">
                  <label>Override</label>
                  <Switch
                    checked={bunkerPriceOverridden}
                    onChange={(e) => onChangeBunkerPriceOverridden(e)}
                    name="bunkerPriceOverridden"
                    color="primary"
                  />
                </div>

                {/* Bunker Prices */}
                <table className="fleet-result-table w-full" style={{ tableLayout: "fixed" }}>
                  <thead>
                    <tr>
                      <th style={{ width: "37%" }}>Bunker Prices</th>
                      <th style={{ width: "21%" }}>Main</th>
                      <th style={{ width: "21%" }}>ECA</th>
                      <th style={{ width: "21%" }}>MGO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>On Delivery</th>
                      <td>
                        {!bunkerPriceOverridden ? (
                          <p>{bnkPriceDeliveryhs}</p>
                        ) : (
                          <input
                            onKeyDown={handleKeyDown}
                            type="number"
                            value={bnkPriceDeliveryhs}
                            disabled={!bunkerPriceOverridden}
                            name="bnkPriceDeliveryhs"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        )}
                      </td>
                      <td>
                        {!bunkerPriceOverridden ? (
                          <p>{bnkPriceDeliveryls}</p>
                        ) : (
                          <input
                            onKeyDown={handleKeyDown}
                            type="number"
                            value={bnkPriceDeliveryls}
                            disabled={!bunkerPriceOverridden}
                            name="bnkPriceDeliveryls"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        )}
                      </td>
                      <td>
                        {!bunkerPriceOverridden ? (
                          <p>{bnkPriceDeliverymgo}</p>
                        ) : (
                          <input
                            onKeyDown={handleKeyDown}
                            type="number"
                            value={bnkPriceDeliverymgo}
                            disabled={!bunkerPriceOverridden}
                            name="bnkPriceDeliverymgo"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>On Re-Delivery</th>
                      <td>
                        {!bunkerPriceOverridden ? (
                          <p>{bnkPriceRedeliveryhs}</p>
                        ) : (
                          <input
                            onKeyDown={handleKeyDown}
                            type="number"
                            value={bnkPriceRedeliveryhs}
                            name="bnkPriceRedeliveryhs"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        )}
                      </td>
                      <td>
                        {!bunkerPriceOverridden ? (
                          <p>{bnkPriceRedeliveryls}</p>
                        ) : (
                          <input
                            onKeyDown={handleKeyDown}
                            type="number"
                            value={bnkPriceRedeliveryls}
                            name="bnkPriceRedeliveryls"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        )}
                      </td>
                      <td>
                        {!bunkerPriceOverridden ? (
                          <p>{bnkPriceRedeliverymgo}</p>
                        ) : (
                          <input
                            onKeyDown={handleKeyDown}
                            type="number"
                            value={bnkPriceRedeliverymgo}
                            name="bnkPriceRedeliverymgo"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>For Settlement</th>
                      <td>
                        {!bunkerPriceOverridden ? (
                          <p>{bnkPriceSettlemenths}</p>
                        ) : (
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkPriceSettlemenths}
                            name="bnkPriceSettlemenths"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        )}
                      </td>
                      <td>
                        {!bunkerPriceOverridden ? (
                          <p>{bnkPriceSettlementls}</p>
                        ) : (
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkPriceSettlementls}
                            name="bnkPriceSettlementls"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        )}
                      </td>
                      <td>
                        {!bunkerPriceOverridden ? (
                          <p>{bnkPriceSettlementmgo}</p>
                        ) : (
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={bnkPriceSettlementmgo}
                            name="bnkPriceSettlementmgo"
                            onChange={(e) =>
                              onChangeSelectedVessel(e, true)
                            }
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Right 4 Columns on desktop: Vessel Text Description */}
      <Grid item xs={12} lg={4} className="lg:pl-3 flex flex-col mt-3 lg:mt-0">
        <div className="text-[12px] font-semibold text-slate-700 mb-1.5 tracking-tight">
          Vessel Text Description
        </div>
        <textarea
          value={
            vessel?.selectedVessel?.vesselExtraDetails?.vesselTextDescription === "0"
              ? ""
              : (vessel?.selectedVessel?.vesselExtraDetails?.vesselTextDescription || "")
          }
          name="vesselTextDescription"
          onChange={(e) => onChangeSelectedVessel(e, true)}
          className="w-full flex-1 min-h-[250px] lg:min-h-[480px] text-[11px] font-mono p-3 bg-white border border-slate-300 rounded-none focus:border-[#313C4C] focus:outline-none placeholder:text-slate-400 resize-none transition-colors"
          placeholder="Paste or enter vessel description here..."
        />
      </Grid>
    </Grid>
  );
});

export default EditVesselOnFleetAdd;
